import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';
import styled from 'styled-components';

export const VehicleDetailsWrapper = styled.div`
    width: 100%;
    max-width: 100%;
`;

export const VehicleDetails = styled.div<{ $bgColor?: string; $isFullPageScroll?: boolean }>`
    background-color: ${({ $bgColor, theme }) => $bgColor || theme.uiBricks.primaryButtonDisabledBorderColor || '#ffffff'};
    width: 100%;
    border-radius: 24px;
    min-height: ${({ $isFullPageScroll }) => ($isFullPageScroll ? 'auto' : '100vh')};
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const HeroRow = styled.div`
    display: flex;
    gap: 16px;
    align-items: stretch;

    @media (max-width: ${BreakPoints.TABLET}) {
        flex-direction: column;
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        flex-direction: column;
    }
`;

export const BottomRow = styled.div`
    display: flex;
    gap: 16px;
    align-items: stretch;

    @media (max-width: ${BreakPoints.PHONE}) {
        flex-direction: column;
    }
`;
